import { render, staticRenderFns } from "./WompiRedirect.vue?vue&type=template&id=4e6afdb0&scoped=true&"
import script from "./WompiRedirect.vue?vue&type=script&lang=js&"
export * from "./WompiRedirect.vue?vue&type=script&lang=js&"
import style0 from "./WompiRedirect.vue?vue&type=style&index=0&id=4e6afdb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6afdb0",
  null
  
)

export default component.exports